import { render, staticRenderFns } from "./marketingList.vue?vue&type=template&id=782255ee&scoped=true&"
import script from "./marketingList.vue?vue&type=script&lang=ts&"
export * from "./marketingList.vue?vue&type=script&lang=ts&"
import style0 from "./marketingList.vue?vue&type=style&index=0&id=782255ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782255ee",
  null
  
)

export default component.exports